import GedcomX from './gedcom_X'

const gcx = GedcomX()
export default function vitalStrings(personData) {
  let birthPlace = ''
  let deathPlace = ''
  let birthPlaceFull = ''
  let deathPlaceFull = ''
  const facts = personData.facts ? personData.facts : null
  const lifespan = personData.lifespan
  let age = 'Unknown'
  let estimatedAge = null

  const birthFact = facts ? facts.find((fact) => fact.type === gcx.BIRTH) : null
  let fullBirthDate = ''
  const deathFact = facts ? facts.find((fact) => fact.type === gcx.DEATH) : null
  // For some reason burialFact isn't found unless the full string is used instead of gcx
  const burialFact = facts ? facts.find((fact) => fact.type === 'http://gedcomx.org/Burial') : null

  const calcAge = (fact) => {
    let fullFactDate
    if (fact && fact.display && fact.display.date) {
      age = fact.display.date.year - birthFact.display.date.year
      try {
        fullFactDate = new Date(fact.dateDescription)
        fullBirthDate = new Date(birthFact.dateDescription)
        age = Math.floor((fullFactDate.getTime() - fullBirthDate.getTime()) / (1000 * 3600 * 24) / 365)
      } catch (e) {
        age = 'Unknown'
      }
    }
    return age
  }

  if (birthFact && birthFact.display && birthFact.display.date) {
    if (deathFact && deathFact.display && deathFact.display.date) {
      calcAge(deathFact)
    } else if (burialFact && burialFact.display && burialFact.display.date) {
      calcAge(burialFact)
      estimatedAge = true
    } else if (personData.living) {
      try {
        fullBirthDate = new Date(birthFact.dateDescription)
        age = Math.floor((new Date().getTime() - fullBirthDate.getTime()) / (1000 * 3600 * 24) / 365)
      } catch (e) {
        age = 'Unknown'
      }
    }
  }

  if (birthFact && birthFact.display && birthFact.display.place) {
    birthPlace = birthFact.display.place
    birthPlaceFull = birthFact.display.placeFull
  }

  if (deathFact && deathFact.display && deathFact.display.place) {
    if (deathFact.display.place) {
      deathPlace = deathFact.display.place
      deathPlaceFull = deathFact.display.placeFull
    }
  }

  return { age, lifespan, deathPlace, deathPlaceFull, birthPlace, birthPlaceFull, estimatedAge }
}
